/** Fry's 250 Instant Words organized by frequency level */
export const SIGHT_WORD_LEVELS: { level: number; words: string[] }[] = [
    {
        level: 1,
        words: [
            'the', 'of', 'and', 'a', 'to', 'in', 'is', 'you', 'that', 'it',
            'he', 'was', 'for', 'on', 'are', 'as', 'with', 'his', 'they', 'I',
            'at', 'be', 'this', 'have', 'from', 'or', 'one', 'had', 'by', 'but',
            'not', 'what', 'all', 'were', 'we', 'when', 'your', 'can', 'said', 'there',
            'use', 'an', 'each', 'which', 'she', 'do', 'how', 'their', 'if', 'will',
        ],
    },
    {
        level: 2,
        words: [
            'up', 'other', 'about', 'out', 'many', 'then', 'them', 'these', 'so', 'some',
            'her', 'would', 'make', 'like', 'him', 'into', 'time', 'has', 'look', 'two',
            'more', 'go', 'see', 'number', 'no', 'way', 'could', 'people', 'my', 'than',
            'first', 'water', 'been', 'call', 'who', 'its', 'now', 'find', 'long', 'down',
            'day', 'did', 'get', 'come', 'made', 'may', 'part', 'over', 'new', 'after',
        ],
    },
    {
        level: 3,
        words: [
            'sound', 'take', 'only', 'little', 'work', 'know', 'place', 'year', 'live', 'me',
            'back', 'give', 'most', 'very', 'just', 'name', 'good', 'sentence', 'man', 'think',
            'say', 'great', 'where', 'help', 'through', 'much', 'before', 'line', 'right', 'too',
            'mean', 'old', 'any', 'same', 'tell', 'boy', 'follow', 'came', 'want', 'show',
            'also', 'around', 'three', 'small', 'set', 'put', 'end', 'does', 'another', 'well',
        ],
    },
    {
        level: 4,
        words: [
            'large', 'must', 'big', 'even', 'such', 'because', 'turn', 'here', 'why', 'ask',
            'went', 'men', 'read', 'need', 'land', 'different', 'home', 'us', 'move', 'try',
            'kind', 'hand', 'picture', 'again', 'change', 'off', 'play', 'spell', 'air', 'away',
            'animal', 'house', 'point', 'page', 'letter', 'mother', 'answer', 'found', 'study', 'still',
            'learn', 'should', 'world', 'high', 'every', 'near', 'add', 'food', 'between', 'own',
        ],
    },
    {
        level: 5,
        words: [
            'below', 'country', 'plant', 'last', 'school', 'father', 'keep', 'tree', 'never', 'start',
            'city', 'earth', 'eye', 'light', 'thought', 'head', 'under', 'story', 'saw', 'left',
            'few', 'while', 'along', 'might', 'close', 'something', 'seem', 'next', 'hard', 'open',
            'example', 'begin', 'life', 'always', 'those', 'both', 'paper', 'together', 'got', 'group',
            'often', 'run', 'important', 'until', 'children', 'side', 'feet', 'car', 'mile', 'night',
        ],
    },
];

/** Flat set of all 250 sight words for O(1) lookup */
export const SIGHT_WORDS_SET = new Set(
    SIGHT_WORD_LEVELS.flatMap(l => l.words.map(w => w.toLowerCase())),
);
